import { cn } from "../lib/utils"
import Button from "./Button"
import Tooltip from "./Tooltip"
import { useState } from "react"

export const LockedSection = ({
  isLocked,
  lockText = "Complete Student Activities to unlock",
  gridArea,
  unlockAction,
  unlockText,
  children,
  canUnlock = false,
  tooltipText = "",
}) => {
  const [lockOverride, setLockOverride] = useState(false)
  
  const handleLockOverride = () => {
    setLockOverride(true)
  }
  
  if (!isLocked || lockOverride) {
    return <>{children}</>
  }

  // If no gridArea provided, treat as a simple wrapper with overlay (not in a grid)
  if (!gridArea) {
    return (
      <div className="pointer-events-none relative flex min-h-0 flex-1 flex-col">
        {children}
        <div className="pointer-events-auto absolute inset-0 z-10 flex flex-col items-center justify-center rounded-lg bg-neutral-100/95">
          <Tooltip text={tooltipText}>
            <div className="flex flex-col items-center justify-center gap-4">
              <i className="fa-classic fa-lock mb-4 text-6xl text-neutral-400"></i>
              <div className="px-4 text-center text-lg font-medium text-neutral-500">
                {lockText}
              </div>
              <div>
                {unlockAction && unlockText && (
                  <UnlockActionButton onClick={unlockAction}>{unlockText}</UnlockActionButton>
                )}
              </div>
            </div>
          </Tooltip>
          <div className="mt-4">
            <LockOverrideButton onClick={handleLockOverride} />
          </div>
        </div>
      </div>
    )
  }

  // Grid-based locked section
  return (
    <div className="pointer-events-none contents">
      {/* Wrapper for mobile - creates a containing block */}
      <div className="relative flex min-h-0 flex-col md:contents">
        {children}
        {/* Mobile: overlay covers the wrapper */}
        <div className="pointer-events-auto absolute inset-0 z-10 flex flex-col items-center justify-center rounded-lg bg-neutral-100/95 md:hidden">
          <i className="fa-classic fa-lock mb-4 text-4xl text-neutral-400"></i>
          <div className="px-4 text-center text-sm font-medium text-neutral-500">{lockText}</div>
        </div>
      </div>

      {/* Desktop: single overlay spanning grid area */}
      <div
        className={cn(
          "pointer-events-auto z-10 hidden flex-col items-center justify-center bg-neutral-100/95 md:flex",
          gridArea,
        )}
        style={{
          borderRadius: "0.5rem",
        }}
      >
        <Tooltip text={tooltipText}>
          <div className="flex flex-col items-center justify-center gap-4">
            <i className="fa-classic fa-lock mb-4 text-[8rem] text-neutral-400"></i>
            <div className="px-4 text-center text-3xl font-medium text-neutral-500">{lockText}</div>
            <div>
              {unlockAction && unlockText && (
                <UnlockActionButton onClick={unlockAction} disabled={!canUnlock}>
                  {unlockText}
                </UnlockActionButton>
              )}
            </div>
          </div>
        </Tooltip>
        <div className="mt-4">
          <LockOverrideButton onClick={handleLockOverride}/>
        </div>
      </div>
    </div>
  )
}

const UnlockActionButton = ({ onClick, children, disabled }) => {
  return (
    <Button variant="secondary" onClick={onClick} className="mt-4 text-xl" disabled={disabled}>
      {children}
    </Button>
  )
}

const LockOverrideButton = ({ onClick }) => {
  return (
    <button onClick={onClick} className="text-sm text-neutral-500 hover:underline">Preview</button>
  )
}
